import MUIDataTable from 'mui-datatables';
import { MenuItem, Select } from '@material-ui/core';

const options = {
    filterType: 'dropdown',
    selectableRows: 'none',
    print: false,
    download: false
};

const AffiliateTable = ({ affiliates, onProviderChange }) => {
    // TODO: Update the columns to match the data structure
    const nachaProviders = ['wsfs', 'thread'];

    const columns = [
        {
            name: 'id',
            label: 'Affiliate ID',
            options: { display: false, filter: false }
        },
        {
            name: 'visionAffiliateId',
            label: 'Vision Affiliate ID',
            options: { display: true, filter: false }
        },
        {
            name: 'name',
            label: 'Name',
            options: { display: true, filter: false }
        },
        {
            name: 'nachaProvider',
            label: 'Nacha Provider',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowData = tableMeta.rowData;
                    const affiliate = {
                        id: rowData[0],
                        visionAffiliateId: rowData[1],
                        nachaProvider: value,
                    };
                    return (
                        <Select
                            value={affiliate.nachaProvider || ''}
                            onChange={e => onProviderChange(affiliate, e.target.value)}
                            style={{ minWidth: 120 }}
                        >
                            {nachaProviders.map(provider => (
                                <MenuItem key={provider} value={provider}>{provider}</MenuItem>
                            ))}
                        </Select>
                    );
                }
            }
        },

    ];

    const columnsWithProviders = columns.map(col => {
        if (col.name === 'nachaProvider') {
            return {
                ...col,
                options: {
                    ...col.options,
                    customBodyRender: (value, tableMeta, updateValue) => (
                        <Select
                            value={value || ''}
                            onChange={e => onProviderChange(
                                {
                                    id: tableMeta.rowData[0],
                                    visionAffiliateId: tableMeta.rowData[1],
                                    nachaProvider: value,
                                    name: tableMeta.rowData[2]
                                },
                                e.target.value
                            )}
                            style={{ minWidth: 120 }}
                        >
                            {nachaProviders.map(provider => (
                                <MenuItem key={provider} value={provider}>{provider}</MenuItem>
                            ))}
                        </Select>
                    )
                }
            }
        }
        return col;
    });

    return (
        <MUIDataTable
            data={affiliates}
            columns={columnsWithProviders}
            options={options}
        />
    );
};

export default AffiliateTable;
